import {
  Filters,
  FiltersGroup,
  FiltersList,
} from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Filters';
import type { FiltersValues } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Filters/types';

import { useSearchParams } from 'renderer/hooks/useSearchParams';
import { RecipeFilterGroup } from 'services/recipes/types';

import { RECIPE_FILTER_SUFFIX, RECIPE_QUERY_PAGE, RECIPE_QUERY_START_PAGE } from '../constants';

const getFilterParamName = (title: string) => `${title}${RECIPE_FILTER_SUFFIX}`;

const getGroupId = (title: string) => title.toLowerCase().replace(/\s+/g, '-');

const RecipeFilters = ({ filters }: { filters: RecipeFilterGroup[] }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const values: FiltersValues = filters.reduce<FiltersValues>((acc, currentFilter) => {
    const paramName = getFilterParamName(currentFilter.title);
    const selectedValue = searchParams.get(paramName);

    if (selectedValue) {
      acc[paramName] = selectedValue.split(',').filter(Boolean);
    }

    return acc;
  }, {});

  const handleChange = (nextValues: FiltersValues) => {
    const updates: Record<string, string | null> = {};

    filters.forEach(filter => {
      const paramName = getFilterParamName(filter.title);
      const value = nextValues[paramName];

      if (Array.isArray(value) && value.length > 0) {
        updates[paramName] = value.join(',');
      } else {
        updates[paramName] = null;
      }
    });

    updates[RECIPE_QUERY_PAGE] = null;
    updates[RECIPE_QUERY_START_PAGE] = null;

    setSearchParams(updates);
  };

  return (
    <Filters values={values} onChange={handleChange}>
      {filters.map(filter => (
        <FiltersGroup key={filter.title} id={getGroupId(filter.title)} title={filter.title}>
          <FiltersList
            name={getFilterParamName(filter.title)}
            options={filter.values.map(value => ({
              value: value.name,
              count: value.count,
            }))}
          />
        </FiltersGroup>
      ))}
    </Filters>
  );
};

export default RecipeFilters;
